import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/** A plain `scheduledsend` PUT on a held campaign is forced back to `OnHold` server-side. */
export const useRegEdEmailReleaseMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (campaign: Api.ICampaign) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			campaignId,
			schedule,
			impersonationContext,
		}: {
			campaignId: string;
			schedule: Api.IScheduledSend;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<Api.ICampaign>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `email/${encodeURIComponent(campaignId)}/releaseConditionalHold`,
				}),
				'POST',
				schedule
			),
		onError,
		onSuccess: (campaign, { campaignId }) => {
			invalidateRegEdSubmissions(campaignId);
			onSuccess?.(campaign);
		},
	});
};
